export default {
  id: 167,
  title: 'Target #167 - React India',
  url: 'https://cssbattle.dev/play/167',
  colors: ['#0D1335', '#FBFAE2', '#4FA07B', '#DC6638', '#73C6EA'],
  solution:
    '<p a><p b><p c><p d><style>body{background:#0d1335}p{position:fixed}[a],[b],[c]{top:79;left:75;width:230;height:90;border:10px solid;border-radius:100%}[a]{border-color:#fbfae2}[b]{border-color:#4fa07b;transform:rotate(120deg)}[c]{border-color:#dc6638;transform:rotate(60deg)}[d]{background:#73c6ea;top:114;left:180;width:40;height:40;border-radius:9in}</style>',
}
